import React from 'react';
import {
  TableFilters,
  TableFilterSelect,
  BelongsToFilterSelects,
  InputContainer,
} from '../../design-system';
import {
  containerConditionOptions,
  containerTypes,
  INPUT_ERRORS,
  salesStatusOptions,
} from '../../const';
import { i18n } from '../../i18n';
import { extendContainerValidator } from '../../utils';

interface Props {
  yardId?: string;
  clientId?: string;
  number?: string;
  type?: string;
  condition?: string;
  status?: string;
  setStates: any;
}

export const Filters: React.FC<Props> = ({
  number = '',
  type,
  condition,
  status,
  setStates,
}: Props) => {
  return (
    <TableFilters>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
        filtersType={'managesales'}
      />
      {!Array.isArray(number) && (
        <InputContainer
          label={i18n.t('label.containerNumber')}
          data-size={'medium'}
          defaultValue={number}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            setStates('number', value);
          }}
          helperText={
            number.length !== 0 && number.length < 3
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
              : !extendContainerValidator(number)
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
              : ''
          }
          alwaysShowHelperText
        />
      )}
      <TableFilterSelect
        label={i18n.t('label.type')}
        options={containerTypes}
        value={type}
        onChange={(e) => setStates('force', { type: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.condition')}
        options={containerConditionOptions}
        value={condition}
        onChange={(e) => setStates('force', { condition: e.target.value })}
      />
      {!Array.isArray(number) && (
        <TableFilterSelect
          label={i18n.t('label.status')}
          options={salesStatusOptions}
          value={status}
          onChange={(e) => {
            setStates('force', {
              status: e.target.value,
            });
          }}
        />
      )}
    </TableFilters>
  );
};
